import { ServerNode } from "../../../Http/ServerNode.js";
import { throwError } from "../../../Exceptions/index.js";
import { HttpRequestParameters } from "../../../Primitives/Http.js";
import { RavenCommand } from "../../../Http/RavenCommand.js";

export class HiloReturnCommand extends RavenCommand<void> {

    public get isReadRequest() {
        return false;
    }

    private readonly _tag: string;
    private readonly _last: number;
    private readonly _end: number;

    public constructor(tag: string, last: number, end: number) {
        super();

        if (last < 0) {
            throwError("InvalidArgumentException", "last is < 0");
        }

        if (end < 0) {
            throwError("InvalidArgumentException", "end is < 0");
        }

        if (!tag) {
            throwError("InvalidArgumentException", "tag cannot be null");
        }

        this._tag = tag;
        this._last = last;
        this._end = end;
        this._responseType = "Empty";
    }

    public createRequest(node: ServerNode): HttpRequestParameters {
        const uri = `${node.url}/databases/${node.database}/hilo/return?`
            + `tag=${this._tag}&end=${this._end}&last=${this._last}`;
        return {
            method: "PUT",
            uri
        };
    }
}
